module.exports = require('./dist/base64url').default;
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ../solid-auth-oidc/~/base64url/index.js
// module id = 108
// module chunks = 0